import Rollbar from 'rollbar';
import { isProduction } from '../../lib/isProduction';
import { getRollbarSettingsByApp, type RollbarAppName } from './getRollbarSettingsByApp';
import { getSensitiveDataHidden } from './getSensitiveDataHidden';

let rollbar: Rollbar | undefined;

function initRollbar(isProduction: boolean, isRollbarEnabled: boolean, appName?: RollbarAppName): Rollbar | undefined {
  if (isProduction && !rollbar) {
    const accessTokenIndex = document.cookie.toLocaleLowerCase().indexOf('openx3_access_token=');
    const hasAccessToken = accessTokenIndex > -1;
    const settings = getRollbarSettingsByApp(appName);

    return new Rollbar({
      accessToken: settings.accessToken,
      captureUncaught: true,
      captureUnhandledRejections: true,
      enabled: isRollbarEnabled,
      scrubFields: ['access_token', 'refresh_token', 'id_token', 'client_id', 'session_id', 'cookie_access_token'],
      payload: {
        client: {
          javascript: {
            code_version: '0.0.1',
            guess_uncaught_frames: true,
            source_map_enabled: true,
          },
        },
        environment: window.location.hostname,
        extra_data: {
          cookie_access_token: hasAccessToken
            ? `${document.cookie.slice(accessTokenIndex + 20, accessTokenIndex + 50)}****`
            : '',
          has_access_token_cookie: hasAccessToken,
          storage: getSensitiveDataHidden(window.localStorage),
        },
      },
    });
  }

  return undefined;
}

interface UseRollbar {
  initialize: () => void;
  rollbar?: Rollbar;
}

export const useRollbar = (appName?: RollbarAppName): UseRollbar => {
  const isLocalDevelopment = window.location.hostname === 'localhost';
  const isRollbarEnabled = isProduction() && !isLocalDevelopment;

  function initialize(): void {
    rollbar = initRollbar(isProduction(), isRollbarEnabled, appName);
  }

  return { initialize, rollbar };
};
